import { Box } from "@sembark-travel/ui-base"
import { CustomerPaymentPreferenceList } from "../../../../CustomerPaymentPreferences"
import { Helmet } from "react-helmet-async"

export default function OrganizationCustomerPaymentPreferencePage() {
	return (
		<>
			<Helmet>
				<title>Customer Payment Preferences | Org</title>
			</Helmet>
			<Box>
				<CustomerPaymentPreferenceList />
			</Box>
		</>
	)
}
